import { render, staticRenderFns } from "./myCard.vue?vue&type=template&id=1735c34e&scoped=true"
import script from "./myCard.vue?vue&type=script&lang=js"
export * from "./myCard.vue?vue&type=script&lang=js"
import style0 from "./myCard.vue?vue&type=style&index=0&id=1735c34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735c34e",
  null
  
)

export default component.exports